const PaymentMethod = Object.freeze({
  TextLink: 'Text Link',
  EmailLink: 'Email Link',
  Manual: 'Manual',
  CardReader: 'Card Reader',
  Draft: 'Draft',
});

export default PaymentMethod;
